import React from 'react';
import { Container, Row } from 'shards-react';

import PageTitle from '../../../components/PageTitle';
import Errors from '../../../components/Errors';
import { usePayments } from '../../../hooks/queries/usePayments';
import { useUrlState } from '../../../hooks/useUrlState';
import {
  dateOnlyParam,
  oneOfParam,
  positiveIntegerParam,
  stringParam
} from '../../../utils/urlStateParams';
import Constants from '../../../data/Constants';
import GenericSearchBar from '../../../components/common/GenericSearchBar/GenericSearchBar';
import { Provider as LoadingProvider } from '../../../contexts/LoadingContext';
import Table from './Table';
import EstablishmentNumberInput from '../../../components/inputs/EstablishmentNumberInput';
import DateInput from '../../../components/inputs/DateInput';
import CardBrandInput from '../../../components/inputs/CardBrandInput';
import DocumentTypeInput from '../../../components/inputs/DocumentTypeInput';
import PaymentOrderInput from '../../../components/inputs/PaymentOrderInput';
import WithPlaceHolderAndKey from '../../../components/inputs/WithPlaceHolderAndKey';

const inputs = [
  EstablishmentNumberInput,
  WithPlaceHolderAndKey(DateInput, 'Fecha desde', 'dateFrom'),
  WithPlaceHolderAndKey(DateInput, 'Fecha hasta', 'dateTo'),
  CardBrandInput,
  DocumentTypeInput,
  PaymentOrderInput
];

const ORDER_BY_VALUES = ['created_at', 'payment_date'];

const URL_STATE_CONFIG = {
  establishmentNumberOrId: stringParam(),
  dateFrom: dateOnlyParam(),
  dateTo: dateOnlyParam(),
  cardBrand: stringParam(),
  documentType: stringParam(),
  orderBy: oneOfParam(ORDER_BY_VALUES, 'created_at'),
  page: positiveIntegerParam()
};

const List = () => {
  const [urlState, setUrlState] = useUrlState(URL_STATE_CONFIG);
  const offset = (urlState.page - 1) * Constants.elementsPerPage;
  const queryFilter = {
    paymentDateFrom: urlState.dateFrom || undefined,
    paymentDateTo: urlState.dateTo || undefined,
    establishmentNumber: urlState.establishmentNumberOrId || undefined,
    cardBrand: urlState.cardBrand || undefined,
    documentType: urlState.documentType || undefined,
    orderBy: urlState.orderBy === 'created_at' ? undefined : urlState.orderBy
  };

  const { payments, loading, error } = usePayments(queryFilter, {
    limit: Constants.elementsPerPage,
    offset
  });

  const onSubmit = (newFilter) => {
    setUrlState({
      establishmentNumberOrId: newFilter.establishmentNumberOrId?.trim() || '',
      dateFrom: newFilter.dateFrom || '',
      dateTo: newFilter.dateTo || '',
      cardBrand: newFilter.cardBrand || '',
      documentType: newFilter.documentType || '',
      orderBy: newFilter.orderBy || 'created_at',
      page: 1
    });
  };

  const handlePageClick = (direction) => {
    const page = urlState.page + direction;
    if (page >= 1) setUrlState({ page });
  };

  return (
    <Container className="main-content-container px-4" fluid>
      <Row className="page-header py-4" noGutters>
        <PageTitle className="text-sm-left" sm="4" subtitle="" title="Liquidaciones" />
      </Row>
      <LoadingProvider value={loading}>
        <GenericSearchBar handleSubmit={onSubmit} inputs={inputs} values={urlState} />
        <Errors errors={error ? ['No se pudieron cargar las liquidaciones.'] : null} />
        <Table
          disableNext={payments.length < Constants.elementsPerPage}
          disablePrev={urlState.page === 1}
          onPageClick={handlePageClick}
          payments={payments}
        />
      </LoadingProvider>
    </Container>
  );
};

export default List;
